// Relais du GLISSEMENT commencé sur une annonce native Google (iOS uniquement : la vue native est posée par-dessus
// la WKWebView et iOS ne permet pas de rejouer un toucher dans la page ; Android relaie les MotionEvents dans le
// plugin lui-même). Le plugin (patch Yalola) émet onNativeAdDrag { phase: "start" | "move" | "end", dx, dy (pt = px
// CSS), vx, vy (pt/s) } — le tap, lui, reste à l'annonce (clic Google intact).
//  - Fil / Profil (mode « live ») : le conteneur (page ou ancêtre overflow) suit le doigt, puis inertie à la
//    décélération UIScrollView (0.998 / ms) ;
//  - Reels (mode « snap », scroll-snap obligatoire → un scrollTop partiel serait aussitôt re-snappé) : le
//    glissement vaut un swipe → reel suivant / précédent (12 % de la hauteur ou 250 pt/s), comme stepReel.
export const DECEL_PER_MS = 0.998;
export const SWIPE_RATIO = 0.12;
export const SWIPE_VELOCITY = 250;
const MIN_SPEED = 0.02; // px/ms — en dessous l'inertie s'arrête

// Ancêtre qui défile (overflow-y auto/scroll), null = la page elle-même.
export const scrollParent = (el) => {
  let p = el?.parentElement;
  while (p && p !== document.body) {
    const oy = getComputedStyle(p).overflowY;
    if (oy === "auto" || oy === "scroll") return p;
    p = p.parentElement;
  }
  return null;
};

// getTarget() → { el: conteneur | null (page), snap: bool } de l'annonce affichée, ou null (rien à faire défiler).
export function createNativeAdDragRelay(getTarget) {
  let target = null;
  let total = { x: 0, y: 0 };
  let raf = 0;
  const stop = () => { if (raf) { cancelAnimationFrame(raf); raf = 0; } };
  const scrollBy = (t, dx, dy) => {
    if (!t.el) { window.scrollBy(dx, dy); return; }
    t.el.scrollTop += dy;
    t.el.scrollLeft += dx;
  };
  const momentum = (t, vx, vy) => {
    let sx = -vx / 1000, sy = -vy / 1000; // px/ms — le contenu part à l'opposé du doigt
    if (Math.abs(sx) + Math.abs(sy) <= MIN_SPEED) return;
    let last = performance.now();
    const step = (now) => {
      const dt = Math.min(64, Math.max(1, now - last));
      last = now;
      scrollBy(t, sx * dt, sy * dt);
      const k = Math.pow(DECEL_PER_MS, dt);
      sx *= k; sy *= k;
      raf = Math.abs(sx) + Math.abs(sy) > MIN_SPEED ? requestAnimationFrame(step) : 0;
    };
    raf = requestAnimationFrame(step);
  };
  const swipe = (t, vy) => {
    const c = t.el;
    if (!c) return;
    const h = c.clientHeight || 1;
    const idx = Math.round(c.scrollTop / h);
    let d = 0;
    if (total.y < -h * SWIPE_RATIO || vy < -SWIPE_VELOCITY) d = 1;
    else if (total.y > h * SWIPE_RATIO || vy > SWIPE_VELOCITY) d = -1;
    if (d) c.scrollTo({ top: Math.max(0, idx + d) * h, behavior: "smooth" });
  };
  return (e) => {
    const phase = e?.phase;
    if (phase === "start") {
      stop();
      const t = getTarget();
      target = t ? { el: t.el || null, snap: !!t.snap } : null;
      total = { x: 0, y: 0 };
      return;
    }
    if (!target) return;
    if (phase === "move") {
      const dx = Number(e.dx) || 0, dy = Number(e.dy) || 0;
      total.x += dx; total.y += dy;
      if (!target.snap) scrollBy(target, -dx, -dy);
      return;
    }
    if (phase === "end") {
      const vx = Number(e.vx) || 0, vy = Number(e.vy) || 0;
      if (target.snap) swipe(target, vy); else momentum(target, vx, vy);
      target = null;
    }
  };
}
